import {create} from 'zustand'
import {persist} from 'zustand/middleware'
import {IUserPreferences} from '../types/auth'

type SidebarView = 'legacy' | 'new'

type State = {
  sidebarView: SidebarView
  sidebarFavorites: string[]
  expandedSections: string[]
}

type Actions = {
  setSidebarView: (view: SidebarView) => void
  setFavorites: (favorites: string[]) => void
  toggleFavorite: (route: string) => void
  toggleSection: (sectionId: string) => void
  hydrate: (prefs: IUserPreferences) => void
  reset: () => void
}

export const useUserPreferencesStore = create<State & Actions>()(
  persist(
    (set) => ({
      sidebarView: 'new',
      sidebarFavorites: [],
      expandedSections: [],
      setSidebarView: (view) => set({sidebarView: view}),
      setFavorites: (favorites) => set({sidebarFavorites: favorites}),
      toggleFavorite: (route) =>
        set((state) => ({
          sidebarFavorites: state.sidebarFavorites.includes(route)
            ? state.sidebarFavorites.filter((r) => r !== route)
            : [...state.sidebarFavorites, route],
        })),
      toggleSection: (sectionId) =>
        set((state) => ({
          expandedSections: state.expandedSections.includes(sectionId)
            ? state.expandedSections.filter((s) => s !== sectionId)
            : [...state.expandedSections, sectionId],
        })),
      hydrate: (prefs) =>
        set({
          sidebarView: prefs.sidebar_view ?? 'new',
          sidebarFavorites: prefs.sidebar_favorites ?? [],
        }),
      reset: () => set({sidebarView: 'new', sidebarFavorites: [], expandedSections: []}),
    }),
    {name: 'user-preferences'}
  )
)
